import { LoggedUser } from "../structures";
import { LOGGED_USER } from "../actions-constants/loggedUser.constants";

const initialLoggedUser = new LoggedUser()

export function loggedUserReducer(loggedUser: LoggedUser = initialLoggedUser, action):LoggedUser {
    switch (action.type) {
        case LOGGED_USER.USER_LOGGED_IN:
            let newLoggedUser = new LoggedUser()
            newLoggedUser.isLogged = true
            return Object.assign(newLoggedUser,action.user)
        case LOGGED_USER.USER_LOGGED_OUT:
            const loggedOutUser = new LoggedUser()
            return loggedOutUser
        default:
            return loggedUser;
    }
}